import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            mx: 'auto',
            width: '100%',
        },
        heading: {
            px: remCalc(24),
            py: {base: remCalc(16), md: remCalc(40)},
            maxWidth: {base: remCalc(1280), md: '100%'},
            textStyle: 'head-large',
            fontWeight: 'medium',
        },
        media: {
            width: '100%',
        },
        list: {
            liststyle: 'none',
            marginLeft: remCalc(24),
            marginRight: remCalc(24),
        },
        listli: {
            display: 'flex',
            marginBottom: remCalc(40),
        },
        listnum: {
            display: 'block',
            borderRadius: '50%',
            border: '1px solid',
            minW: remCalc(38),
            maxH: remCalc(38),
            lineHeight: remCalc(38),
            textAlign: 'center',
            mr: remCalc(16),
            textStyle: 'body-large',
            fontWeight: 'normal',
        },
        listtitle: {
            textStyle: 'head-small',
            fontWeight: 'medium',
            pb: remCalc(8),
        },
        listbody: {
            textStyle: 'body-large',
            fontWeight: 'normal',
        },
        cta: {
            mx: remCalc(24),
            mb: remCalc(24),
            minW: {base: 'auto', md: remCalc(310), lg: remCalc(213)},
            textDecoration: 'none !important',
        },
    },
}
